import { useQuery } from '@tanstack/react-query';

import { useDeps } from '@Contexts/DI';
import { useRequest } from '@Contexts/Request';
import * as Profile from '@Queries/Profile';

/**
 * NOTE: Данный запрос возвращает персонализированную информацию, поэтому он не должен выполняться во время серверного рендера,
 * т.к. это лишает нас возможности кэшировать страницы для улучшения производительности
 */
export const useBonusHistory = () => {
  const request = useRequest();
  const { cabinetApi } = useDeps();
  const profile = Profile.useProfile();
  const keys = ['bonus-history', { mindboxId: profile.data?.mindboxId }];

  const query = useQuery({
    queryKey: keys,
    queryFn: () => cabinetApi.fetchBonusHistory(request),
    enabled: true,
  });

  return query;
};
